import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { NumberParam, StringParam, useQueryParam, withDefault } from 'use-query-params';
import { LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import { formatDate } from '@sierralabs/core';
import { AppSnackbar, WrappedTableCell } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
import { useFindReports } from '../hooks/useFindReports';
const StyledTableContainer = styled(TableContainer) `
  .shared-cell {
    padding-top: 2px;
    padding-bottom: 2px;
  }
`;
export const ReportListTable = props => {
    const { search } = props;
    const history = useHistory();
    const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 0));
    const [limit, setLimit] = useQueryParam('limit', withDefault(NumberParam, 100));
    const [order, setOrder] = useQueryParam('order', StringParam);
    const [direction, setDirection] = useQueryParam('direction', StringParam);
    const [error, setError] = useState();
    const { editorPath } = useSiteContext();
    const { reportList, loadingReports, loadingReportsError, findReports } = useFindReports();
    const handleSort = (column) => {
        setOrder(column);
        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
    };
    const getSortDirection = (column) => {
        return order === column && direction === 'DESC' ? 'desc' : 'asc';
    };
    useEffect(() => {
        const params = {
            page,
            limit,
            order: order || 'report.id',
            direction: direction || 'ASC'
        };
        if (search)
            params.search = search;
        findReports(params);
    }, [page, limit, order, direction, search, findReports]);
    useEffect(() => {
        setError(loadingReportsError);
    }, [loadingReportsError]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTableContainer, null,
            React.createElement(Table, { stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null,
                            React.createElement(TableSortLabel, { active: order === 'query.name', direction: getSortDirection('query.name'), onClick: () => handleSort('query.name') }, "Report Name")),
                        React.createElement(TableCell, null,
                            React.createElement(TableSortLabel, { active: order === 'report.shared', direction: getSortDirection('report.shared'), onClick: () => handleSort('report.shared') }, "Shared")),
                        React.createElement(TableCell, null,
                            React.createElement(TableSortLabel, { active: order === 'createdBy.firstName', direction: getSortDirection('createdBy.firstName'), onClick: () => handleSort('createdBy.firstName') }, "Created By")),
                        React.createElement(TableCell, null,
                            React.createElement(TableSortLabel, { active: order === 'report.created', direction: getSortDirection('report.created'), onClick: () => handleSort('report.created') }, "Created Date")),
                        React.createElement(TableCell, null,
                            React.createElement(TableSortLabel, { active: order === 'report.modified', direction: getSortDirection('report.modified'), onClick: () => handleSort('report.modified') }, "Last Modified")))),
                React.createElement(TableBody, null,
                    loadingReports && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 5, padding: 'none' },
                            React.createElement(LinearProgress, null)))), reportList === null || reportList === void 0 ? void 0 :
                    reportList.data.map(report => (React.createElement(TableRow, { hover: true, key: report.id, onClick: () => {
                            history.push(`${editorPath}reports/${report.id}`);
                        } },
                        React.createElement(WrappedTableCell, null, report.query.name),
                        React.createElement(TableCell, { className: 'shared-cell' }, report.shared && React.createElement(Check, null)),
                        React.createElement(WrappedTableCell, null,
                            report.createdBy.firstName,
                            " ",
                            report.createdBy.lastName),
                        React.createElement(WrappedTableCell, null, formatDate(report.created, true)),
                        React.createElement(WrappedTableCell, null, formatDate(report.modified)))))))),
        React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 100], component: 'div', count: (reportList === null || reportList === void 0 ? void 0 : reportList.total) || 0, rowsPerPage: limit, page: page, onPageChange: (_, newPage) => setPage(newPage), onRowsPerPageChange: event => {
                setLimit(+event.target.value);
                setPage(0);
            } }),
        React.createElement(AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
export default ReportListTable;
//# sourceMappingURL=ReportListTable.js.map